import { useRef } from 'react';
import { useTranslation } from '../../i18n/i18n';
import { ApiProduct } from '../../types';
import { Img } from '../Img/Img';

interface OrderReturnItemProps {
	product: ApiProduct;
	returnQuantity: number;
	productCondition?: 'unbroken' | 'opened_unused' | 'used' | null;
}

export const OrderReturnItem = ({ product, returnQuantity, productCondition }: OrderReturnItemProps) => {
	const t = useTranslation().returnOrder;

	const imgRef = useRef<HTMLImageElement>(null);

	const getProductConditionText = (): string | null => {
		switch (productCondition) {
			case 'unbroken':
				return t.conditionUnbroken;
			case 'opened_unused':
				return t.conditionOpenedUnused;
			case 'used':
				return t.conditionUsed;
			default:
				return null;
		}
	};

	const productConditionText = getProductConditionText();

	return (
		<>
			<div className="product-image">
				<Img ref={imgRef} src={product.image} width={50} height={50} alt={product.name} />
			</div>
			<div className="product-details">
				<div className="product-meta">
					<a href={'/' + product.perma}>{product.name}</a>
					{productConditionText && (
						<div className="selected-product-condition">
							<strong>{t.productState}:</strong> {productConditionText}
						</div>
					)}
				</div>
				<div className="selected-product-quantity">
					<strong>
						{t.quantity} {returnQuantity}
					</strong>
				</div>
			</div>
		</>
	);
};
